import { createContainerStructure } from 'client/utils/createStructureUtils'
import { createAgreement } from 'src/shared/entities/agreement/create-agreement'
import { createPopup } from 'src/shared/entities/popup/create-popup'

export const createPopupWithAgreementFromLibrary = (locale: string) => {
  const popupEntity = createPopup()

  const { structure, descendantEntity } = createContainerStructure(
    popupEntity,
    locale,
    0,
  )

  const agreement = createAgreement(descendantEntity.id)

  return {
    ascendantId: popupEntity.id,
    structure: {
      ...structure,
      [descendantEntity.id]: {
        ...descendantEntity,
        childIds: [agreement.id],
      },
      [popupEntity.id]: {
        ...popupEntity,
        childIds: [structure[descendantEntity.parentId as string].id],
      },
      [agreement.id]: agreement,
    },
  }
}
